<template>
  <div class='newplace full_layout'>
    <img src="/static/images/activty/newplace/newplace_01.jpg">
    <img src="/static/images/activty/newplace/newplace_02.jpg">
    <img src="/static/images/activty/newplace/newplace_03.jpg">
    <img src="/static/images/activty/newplace/newplace_04.jpg">
    <img src="/static/images/activty/newplace/newplace_05.jpg">
  </div>
</template>
<script>
export default {
  name: '',
  components: {},
  data() {
    return {
    }
  },
  watch: {
  },
  mounted() {},
  created() {
    this.$store.commit('SET_HEADER_TITLE', this.$t('title.newPlaceToBuy'));
  },
  methods: {
    
  },
}

</script>
<style scoped>
.newplace img{
  width: 100%;
  display: block;
  overflow: hidden;
}

</style>



// WEBPACK FOOTER //
// src/components/activity/newplace.vue